import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILogInReqParams, LogInType, UserInfoInterface } from '@models/auth/authModel';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

export const TOKEN_TIME_OUT = 600 * 1000;

// TODO: 아래의 더미는 추후 삭제처리 할 것!
export const DummyUserInfo = {
  email: 'admin@admin.aix.com',
  isSignupComplete: 'Y',
  memberId: '123',
  password: '123',
  profileImageUrl:
    'https://is3-ssl.mzstatic.com/image/thumb/Purple112/v4/b5/4d/0c/b54d0c37-cea9-6f44-8973-a3ea365a4a73/source/512x512bb.jpg',
  // providerType?: string;
  // registerDatetime?: number[];
  serviceCode: '1',
  userId: 'admin',
  userName: 'userName',
  userRole: 'admin',
  teamName: 'AIX',
  phoneNumber: '010-1234-5678',
  phoneNumber1: '010-1234-5678',
  subAccount: [
    {
      teamName: 'AIX1',
      teamId: '11',
      email: 'AIX1@aix.com',
    },
    {
      teamName: 'AIX2',
      teamId: '22',
      email: 'AIX2@aix.com',
    },
  ],
};

// 로그인 함수
export const fetchLogin = createAsyncThunk('fetchLogin', async (params: ILogInReqParams) => {
  const { type, email, password } = params;
  // TODO: 요청 주소가 다를땐 아래에서 분기처리할것..
  switch (type) {
    case LogInType.aix:
      break;
    case LogInType.facebook:
      break;
    case LogInType.google:
      break;
    default:
      break;
  }

  const { data: userInfoData, status: userInfoStatus } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
    params,
  });
  if (userInfoStatus === 200) {
    return {
      message: userInfoData.data,
      data: DummyUserInfo,
    };
  } else {
    alert('백엔드 정보~ 가 잘못되었습니다.');
    return {
      message: 'WRONG_PASSWORD',
    };
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    authenticated: false as boolean,
    accessToken: null as string | null,
    expireTime: null as number | null,
    userInfo: DummyUserInfo as UserInfoInterface,
  },
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.authenticated = true;
      state.accessToken = action.payload;
      state.expireTime = new Date().getTime() + TOKEN_TIME_OUT;
    },
    delAccessToken: (state) => {
      state.authenticated = false;
      state.accessToken = null;
      state.expireTime = null;
    },
    setUserInfo: (state) => {
      state.userInfo = null; //TODO: 유저 정보 인터페이스 생성 연동 해야 함.
    },
    setLogOut: (state) => {
      state.authenticated = false;
      state.accessToken = null;
      state.expireTime = null;
      state.userInfo = null;
    },
    setAuthSuccess: (state) => {
      state.authenticated = true;
    },
    changeSubAccountTeamName: (state, { payload: { teamName, email, teamId } }) => {
      const subAccountObjIndex = state.userInfo.subAccount.findIndex((item) => item.email === email);
      state.userInfo.subAccount[subAccountObjIndex] = { teamName: teamName, email: email, teamId: teamId };
      // const updateSubAccountObj = Object.assign(state.userInfo.subAccount, {});
      // state.userInfo = {...state.userInfo, ...state.userInfo.subAccount}
    },
  },
  extraReducers: {
    // login 관련
    [fetchLogin.fulfilled.type]: (state, { payload }: { payload: { message: string; data?: any } }) => {
      const { data, message } = payload;
      if (data) {
        state.userInfo = data;
      }
    },
  },
});

export const { setAccessToken, delAccessToken, setUserInfo, setAuthSuccess, setLogOut, changeSubAccountTeamName } =
  authSlice.actions;
export const authSliceName = authSlice.name;
export default authSlice.reducer;
